import {
  SecurityBySymbolInfoFragment,
  SecurityPerformanceBySymbolFragment,
  TierKey,
} from 'generated/types'
import { getPlatform } from 'utils/platform'

export const getMarketDetails = (
  securityInfo: SecurityBySymbolInfoFragment | undefined | null,
  securityPerformance: SecurityPerformanceBySymbolFragment | undefined | null,
  ytdReturn: number | undefined,
) => ({
  opening_price: `$${securityInfo?.openPrice.value}`,
  previous_closing_price: `$${securityInfo?.lastClosePrice.value}`,
  week_range_52: `$${securityInfo?.week52Low}-${securityInfo?.week52High}`,
  volume: securityInfo?.volume,
  year_to_date_return: `${ytdReturn}%`,
  market_gain_loss: `$${securityPerformance?.gain?.marketValue?.value}`,
  market_gain_loss_percentage: `${securityPerformance?.gain?.percent}%`,
})

export const FundDetailScreenViewed = (
  securityInfo: SecurityBySymbolInfoFragment | undefined | null,
  securityPerformance: SecurityPerformanceBySymbolFragment | undefined | null,
  ytdReturn: number | undefined,
  product: string,
  portfolioTheme: string,
  portfolioRisk: string,
  subscriptionTier?: TierKey,
  objectName = 'Fund Detail',
) => ({
  platform: getPlatform(),
  Object: 'Screen',
  Action: 'Viewed',
  object_name: objectName,
  screen: 'FundDetail',
  screen_name: 'FundDetail',
  investmentProduct: product,
  portfolio_theme: portfolioTheme,
  portfolio_risk: portfolioRisk,
  subscription_tier: subscriptionTier,
  ...getMarketDetails(securityInfo, securityPerformance, ytdReturn),
})

export const InvestmentTimeWindowSelectionTapped = (
  product: string,
  portfolioTheme: string,
  portfolioRisk: string,
  ctaTitle: string,
) => ({
  platform: getPlatform(),
  Object: 'Button',
  Action: 'Tapped',
  feature: 'Fund Details Market',
  object_name: 'InvestmentTimeWindowSelection',
  screen: 'FundDetail',
  screen_name: 'FundDetail',
  investmentProduct: product,
  portfolio_theme: portfolioTheme,
  portfolio_risk: portfolioRisk,
  cta_title: ctaTitle,
})

export const FundMarketGainLossContentViewed = (
  product: string,
  marketGainLoss: string,
  marketGainLossPercentage: string,
  portfolioTheme: string,
  portfolioRisk: string,
) => ({
  platform: getPlatform(),
  Object: 'Content',
  Action: 'Viewed',
  object_name: 'marketGainLoss',
  screen: 'FundDetail',
  screen_name: 'FundDetail',
  investmentProduct: product,
  market_gain_loss: '$' + marketGainLoss,
  market_gain_loss_percentage: '+' + marketGainLossPercentage + '%',
  portfolio_theme: portfolioTheme,
  portfolio_risk: portfolioRisk,
})
